import { Box, Button, Collapse, TextField, useMediaQuery, useTheme } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/styles';
import Flex from 'components/common/Flex';
import Text from 'components/common/Text';
import { observer, useLocalStore } from 'mobx-react';
import { useHistory } from 'react-router-dom';
import { AppTheme, Colors } from 'styles/theme';
import { useTranslation } from 'react-i18next';
import { isMobileDevice } from 'utils/helper';
import { useCallback, useMemo, useRef } from 'react';
import useDepsContainer from 'hooks/useDepsContainer';
import { subscribeEmail } from 'api/users';
import { IconMaskSvg } from 'assets/icons';

interface FooterProps {}

const Footer = (props: FooterProps) => {
  const history = useHistory();
  const theme = useTheme();
  const mdDown = useMediaQuery(theme.breakpoints.down('md'));
  const lgDown = useMediaQuery(theme.breakpoints.down('lg'));
  const smDown = useMediaQuery(theme.breakpoints.down('sm'));
  const styles = useStyles({ ...props, mdDown });
  const state = useLocalStore(() => ({
    subcribeMessage: '',
    error: false,
    loadingSubcribe: false
  }));
  const inputRef: any = useRef();
  const { uiStore } = useDepsContainer();

  const { t, i18n } = useTranslation();
  const cachedT = useMemo(() => t, [t, uiStore.language]);

  const cachedI18n = useMemo(() => i18n, [i18n]);

  const handleSubcribe = async () => {
    window.open('https://forms.gle/kmDPqxdsgheC9Mw16', '_blank');
    // state.loadingSubcribe = true;
    // try {
    //   if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(inputRef.current?.value)) {
    //     await subscribeEmail({ email: inputRef.current?.value });
    //     state.subcribeMessage = cachedT('SubscribedSuccessfully');
    //     state.error = false;
    //   } else {
    //     state.subcribeMessage = cachedT('PleaseEnterValidAddress');
    //     state.error = true;
    //   }
    // } catch (err) {
    //   state.subcribeMessage = cachedT('SomethingWrong');
    //   state.error = true;
    // }
    // state.loadingSubcribe = false;
  };

  const subcribeMessage = (
    <Flex width={'100%'} maxWidth={1100} px={2} my={2}>
      <Flex
        width={'100%'}
        maxWidth={mdDown ? 'unset' : 330}
        height={'fit-content'}
        bgcolor={state.error ? '#E61A1A' : '#12A14B'}
        p={state.subcribeMessage ? 2 : 0}
        border={!state.subcribeMessage ? 'unset' : state.error ? '1px solid #FDDDDD' : '1px solid #17CF60'}
        borderRadius={'8px'}
        boxShadow={state.error ? '0px 2px 16px rgba(35, 36, 41, 0.12)' : '0px 2px 16px rgba(35, 36, 41, 0.12)'}
        centerY
      >
        <Collapse in={!!state.subcribeMessage}>
          <Flex centerY cursorPointer onClick={() => (state.subcribeMessage = '')}>
            <Flex mr={2}>
              {state.error ? (
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8 1.5C4.41015 1.5 1.5 4.41015 1.5 8C1.5 11.5899 4.41015 14.5 8 14.5C11.5899 14.5 14.5 11.5899 14.5 8C14.5 4.41015 11.5899 1.5 8 1.5ZM6.85355 6.14645C6.65829 5.95118 6.34171 5.95118 6.14645 6.14645C5.95118 6.34171 5.95118 6.65829 6.14645 6.85355L7.29289 8L6.14645 9.14645C5.95118 9.34171 5.95118 9.65829 6.14645 9.85355C6.34171 10.0488 6.65829 10.0488 6.85355 9.85355L8 8.70711L9.14645 9.85355C9.34171 10.0488 9.65829 10.0488 9.85355 9.85355C10.0488 9.65829 10.0488 9.34171 9.85355 9.14645L8.70711 8L9.85355 6.85355C10.0488 6.65829 10.0488 6.34171 9.85355 6.14645C9.65829 5.95118 9.34171 5.95118 9.14645 6.14645L8 7.29289L6.85355 6.14645Z"
                    fill="#FFF5F5"
                  />
                </svg>
              ) : (
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M1.5 8C1.5 4.41015 4.41015 1.5 8 1.5C11.5899 1.5 14.5 4.41015 14.5 8C14.5 11.5899 11.5899 14.5 8 14.5C4.41015 14.5 1.5 11.5899 1.5 8ZM10.4069 6.79062C10.5674 6.56591 10.5153 6.25364 10.2906 6.09313C10.0659 5.93263 9.75364 5.98467 9.59313 6.20938L7.4362 9.22909L6.35355 8.14645C6.15829 7.95118 5.84171 7.95118 5.64645 8.14645C5.45118 8.34171 5.45118 8.65829 5.64645 8.85355L7.14645 10.3536C7.25037 10.4575 7.39476 10.5104 7.54124 10.4983C7.68772 10.4862 7.82144 10.4102 7.90687 10.2906L10.4069 6.79062Z"
                    fill="#F5FFF9"
                  />
                </svg>
              )}
            </Flex>
            <Text>{state.subcribeMessage}</Text>
          </Flex>
        </Collapse>
      </Flex>
    </Flex>
  );

  return (
    <Flex
      className={styles.bank}
      style={{ backgroundSize: mdDown ? '200px auto' : '400px auto' }}
      width={'100%'}
      position={'relative'}
      bgcolor={'white'}
    >
      <Flex
        width={mdDown ? '95vw' : '100%'}
        maxWidth={mdDown ? '95vw' : '1280px'}
        margin={'0 auto'}
        zIndex={2}
        column
        center
        pt={0}
        pb={10}
      >
        <Flex
          width={'100%'}
          style={{
            justifyContent: 'center'
          }}
        >
          {/* <Text
            color={'black'}
            style={{
              fontStyle: 'normal',
              fontWeight: '700',
              fontSize: mdDown ? '32px' : '40px',
              lineHeight: mdDown ? '40px' : '48px',
              textAlign: 'center',
              letterSpacing: '-1px'
            }}
          >
            {isMobileDevice() ? cachedT('securityMessage') : cachedT('DontMissOutOnRelationshipPossibilities')}
          </Text> */}
          <Flex className={mdDown ? styles.emailTitleMd : styles.emailTitle}>
            <div dangerouslySetInnerHTML={{ __html: t('DontMissOutOnRelationshipPossibilities') }} />
          </Flex>
        </Flex>
        {/* <Flex
          width={'100%'}
          mt={6}
          style={{
            justifyContent: 'center'
          }}
        >
          <Text
            color={'white'}
            style={{
              fontStyle: 'normal',
              fontWeight: '400',
              fontSize: mdDown ? '18px' : '20px',
              lineHeight: mdDown ? '24px' : '28px',
              textAlign: 'center',
              letterSpacing: mdDown ? '-0.2px' : '-0.3px'
            }}
          >
            {cachedT('SubscribeToMailingListAndStartDating')}
          </Text>
        </Flex> */}
        <Flex mt={6} column className={mdDown ? styles.emailBgMd : styles.emailBg}>
          <Flex width={'100%'} maxWidth={1100} column={mdDown} center={mdDown}>
            {!mdDown && (
              <Flex flexGrow={1} px={2} width={'100%'}>
                <Flex
                  width={'720px'}
                  bgcolor={'white'}
                  borderRadius={'1rem'}
                  p={'16px 16px'}
                  display={'flex'}
                  justifyContent={'space-between'}
                  alignItems={'center'}
                  border={'2px solid #000'}
                  margin={mdDown ? '110px auto 0' : '150px auto 0'}
                  lineHeight={24}
                >
                  {/* <Flex mr={2}>
                  <IconMaskSvg />
                </Flex> */}
                  <TextField
                    variant="standard"
                    fullWidth
                    multiline
                    rows={2}
                    inputRef={inputRef}
                    InputProps={{
                      disableUnderline: true,
                      style: {
                        color: 'black',
                        padding: 0,
                        lineHeight: '24px',
                        fontFamily: "'Nohemi !important",
                        border: 0
                      }
                    }}
                    className="emailText"
                    // placeholder={cachedT('EnterYourEmailAddress')}
                    value={cachedT('HomeFeedbackText')}
                    disabled
                  />
                  <Button
                    variant="primary"
                    style={{
                      background: state.loadingSubcribe ? 'gray' : '#3B3C45',
                      color: 'white',
                      textTransform: 'unset',
                      borderRadius: '40px',
                      fontFamily: "'Nohemi'",
                      fontStyle: 'normal',
                      fontWeight: '700',
                      fontSize: '16px',
                      lineHeight: '24px',
                      // letterSpacing: '-0.2px',
                      // width: 'fit-content',
                      whiteSpace: 'nowrap',
                      padding: '8px 20px',
                      height: '50px',
                      minWidth: '198px',
                      marginLeft: '10px'
                    }}
                    disabled={state.loadingSubcribe}
                    onClick={handleSubcribe}
                  >
                    {cachedT('HomeFeedbackBtn')}
                  </Button>
                </Flex>
              </Flex>
            )}
            {mdDown && (
              <Flex flexGrow={1} px={2} width={'100%'} column>
                <Flex
                  width={'calc(100% - 24px)'}
                  bgcolor={'white'}
                  borderRadius={'40px'}
                  p={'16px 24px'}
                  display={'flex'}
                  justifyContent={'space-between'}
                  alignItems={'center'}
                  border={'2px solid #000'}
                  margin={'110px auto 0'}
                  lineHeight={24}
                >
                  {/* <Flex mr={2}>
                  <IconMaskSvg />
                </Flex> */}
                  <TextField
                    variant="standard"
                    fullWidth
                    multiline
                    // rows={4}
                    inputRef={inputRef}
                    InputProps={{
                      disableUnderline: true,
                      style: {
                        color: 'black',
                        padding: 0,
                        lineHeight: '24px',
                        fontFamily: 'Nohemi',
                        border: 0,
                        fontSize: '16px',
                        fontWeight: '300'
                      }
                    }}
                    className="emailText"
                    // placeholder={cachedT('EnterYourEmailAddress')}
                    value={cachedT('HomeFeedbackText')}
                    disabled
                  />
                </Flex>
                <Button
                  variant="primary"
                  style={{
                    background: state.loadingSubcribe ? 'gray' : '#3B3C45',
                    color: 'white',
                    textTransform: 'unset',
                    borderRadius: '40px',
                    // fontFamily: 'Nohemi',
                    fontStyle: 'normal',
                    fontWeight: '700',
                    fontSize: '16px',
                    lineHeight: '24px',
                    // letterSpacing: '-0.2px',
                    // width: 'fit-content',
                    whiteSpace: 'nowrap',
                    padding: '8px 20px',
                    height: '50px',
                    width: '204px',
                    margin: '10px auto 40px'
                  }}
                  disabled={state.loadingSubcribe}
                  onClick={handleSubcribe}
                >
                  {cachedT('HomeFeedbackBtn')}
                </Button>
              </Flex>
            )}
            {/* {mdDown && subcribeMessage} */}
          </Flex>
          {/* {!mdDown && subcribeMessage} */}
        </Flex>
      </Flex>
    </Flex>
  );
};

const useStyles = makeStyles((theme: AppTheme) =>
  createStyles({
    bank: {
      // backgroundImage:
      //   "url(/images/home-foot-left.png), url(/images/home-foot-right.png)",
      // backgroundPosition: "left top, right bottom",
      // backgroundRepeat: "no-repeat",
    },
    emailTitle: {
      width: '720px',
      height: '117px',
      // background: 'url(/images/home-email-title.png) center no-repeat',
      // backgroundSize: '595px 117px'
      margin: '0 auto',
      alignItems: 'center',
      justifyContent: 'center',

      '& div': {
        color: '#000',
        textAlign: 'center',
        fontFamily: 'Lexend',
        fontSize: '48px',
        fontWeight: '900',
        lineHeight: '65px',
        letterSpacing: '-1px'
      },

      '& em': {
        display: 'inline-block',
        width: '62px',
        height: '62px',
        background: 'url(images/home-email-icon.svg) left no-repeat',
        backgroundSize: '62px 62px',
        marginRight: '10px',
        verticalAlign: 'top'
      }
    },
    emailTitleMd: {
      width: '100%',
      height: '144px',
      // background: 'url(/images/home-email-title.png) center no-repeat',
      // backgroundSize: '595px 117px'
      margin: '0 auto',
      alignItems: 'center',
      justifyContent: 'center',

      '& div': {
        color: '#000',
        textAlign: 'center',
        fontFamily: 'Lexend',
        fontSize: '40px',
        fontWeight: '900',
        lineHeight: '48px',
        letterSpacing: '-1px'
      },

      '& em': {
        display: 'inline-block',
        width: '36px',
        height: '36px',
        background: 'url(images/home-email-icon.svg) left no-repeat',
        backgroundSize: '36px 36px',
        marginRight: '10px',
        verticalAlign: 'top'
      }
    },
    emailBg: {
      width: '81%',
      height: '0',
      paddingBottom: '23.12%',
      background: 'url(/images/home-email-bg.png) center no-repeat',
      backgroundSize: 'cover',

      '& .emailText': {
        '& textarea': {
          fontFamily: 'Nohemi !important',
          lineHeight: '24px',
          fontSize: '16px',
          fontWeight: '300',
          color: '#232429'
        },
        '& textarea:disabled': {
          color: '#232429',
          textFillColor: '#232429'
        }
      }
    },
    emailBgMd: {
      width: '100%',
      height: '248px',
      background: 'url(/images/mobile/home-email-bg.png) top center no-repeat',
      backgroundSize: '377px 108px'
    }
  })
);

export default observer(Footer);
